import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, ElementRef, AfterViewInit, Renderer2, OnDestroy, NgZone } from "@angular/core";
import { Location } from "@angular/common";
import { CoreLogService } from "../../services/log.service";
import { MatTabGroup, MatTabChangeEvent, MatCheckbox, MatInput, MatCheckboxChange } from "@angular/material";
import { NewsletterCheckboxComponent } from "../../directives";
import { ActivatedRoute, Router } from "@angular/router";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { SnackBarMessageType, LoginStatus } from "../../shared/contentTypes";
import { SettingsRegistrationViewModel } from "../../shared/models/settings.model";
import { TermConfirmationViewModel } from "../../shared/models/term.model";
import { RegisterationUserViewModel } from "../../shared/models/registration.model";
import { RegistrationService } from "./registration.service";
import { ShareDataService } from "../../services/shareDataServic";
import { CoreLanguageService } from "../../services/language.service";
import { BehaviorSubject, Subscription } from "rxjs";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { RouterHelperService } from "../../services/routerHelper.service";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { TermService } from "../term/term.service";
import * as _ from "lodash";
import { FormHelperService } from "../../services/formHelper.service";
import { FormGroup, NgForm } from "@angular/forms";
import { TrackingManager } from "../../services/tracking/tracking-manager";
import { customConfig } from "../../../custom/custom-config";
import { SettingsService } from "../../services/settings.service";
import { CoreCOMService } from "../../services/com.service";

declare const google: any;
declare const FB: any;

@Component({
  selector: "app-registration",
  templateUrl: "./registration.component.html",
  styleUrls: ["./registration.component.scss"],
  providers: [OverlaySpinnerService, FormHelperService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistrationComponent implements OnInit, AfterViewInit, OnDestroy {
  private langSubscriber: Subscription;
  private loginformSubscriber: Subscription;
  private termConfirmationViewModels: TermConfirmationViewModel[] = [];
  private googleClientId: string;
  private facebookAppId: string;

  public returnUrl: string = ""; // navigate to this url after login compelete
  public hasForgetPassword: boolean = false;

  public registerViewModel: RegisterationUserViewModel = new RegisterationUserViewModel();
  public registerPasswordVisibility: boolean = false; // used for show and hide password
  public checkPrivacy: boolean = false;
  public registerFailed: boolean = false;
  public registerFailedMessage: string = "";
  public settingsViewModel: SettingsRegistrationViewModel = new SettingsRegistrationViewModel();
  public checkPrivacyInvalid: boolean;

  public loginViewModel: RegisterationUserViewModel = new RegisterationUserViewModel();
  public loginPasswordVisibility: boolean = false; // used for show and hide password
  public loginFailed: boolean = false;
  public currentHeaderIndex: number = 1;
  public loginTitleContent: string;
  public thirdpartyLoginEnabled = false;
  public thirdpartyGoogleEnabled = false;
  public thirdpartyFacebookEnabled = false;
  private fbInitPromise: Promise<void> | null = null;

  // @ViewChild("registrationTabGroup") matTabGroup: MatTabGroup;
  @ViewChild("privacyContent") privacyContent: ElementRef;
  @ViewChild("loginPassword") loginPassword: HTMLInputElement;
  @ViewChild("registerPassword") registerPassword: HTMLInputElement;
  @ViewChild("chkTerm", { read: MatCheckbox }) chkTerm: MatCheckbox;
  @ViewChild("registerForm", { read: NgForm }) registerForm: NgForm;
  @ViewChild("loginForm", { read: NgForm }) loginForm: NgForm;
  @ViewChild("newsletterCheckbox") newsletterCheckbox: NewsletterCheckboxComponent;


  constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _location: Location
    , private _snackBarService: SnackBarService
    , private _activatedRoute: ActivatedRoute
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _router: Router
    , private _formHelperService: FormHelperService
    , private _shareDataService: ShareDataService
    , private _registrationService: RegistrationService
    , private _termService: TermService
    , private _coreLanguageService: CoreLanguageService
    , private internationalisationService: InternationalisationService
    , private _routerHelperService: RouterHelperService
    , private _renderer: Renderer2
    , private _iosHelperService: IOSHelperService
    , private _trackingManager: TrackingManager
    , private _settingsService: SettingsService
    , private _coreCOMService: CoreCOMService
    , private _cdr: ChangeDetectorRef) {
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("RegistratinComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }

    this.setLoginFormSubscriber();
  }

  private resetRegisterForm() {
    const me = this;
    me.registerFailed = false;
    me.registerFailedMessage = "";
    me.registerPasswordVisibility = false;
    me.checkPrivacy = false;
    me.hasForgetPassword = false;
    me.loginPasswordVisibility = false;
    me.loginFailed = false;
  }

  /**
   * get the login Response and handle login Status(routing to other page, setting sharedata)
   * @param loginStatus response from login user
   */
  private setLoginResponse(loginStatus: LoginStatus) {
    const me = this;
    switch (loginStatus) {
      case LoginStatus.LogedIn:
        {
          me._router.navigateByUrl(me.returnUrl);
          break;
        }
      case LoginStatus.NotVerified:
        {
          me._shareDataService.setSharedDataByKey("registerationUserViewModel", me.loginViewModel);
          me._shareDataService.setSharedDataByKey("returnUrl", me.returnUrl);
          me._router.navigateByUrl("/loginactivation");
          break;
        }
      case LoginStatus.IncompleteRegistration:
        {
          me._shareDataService.setSharedDataByKey("registerationUserViewModel", me.loginViewModel);
          me._shareDataService.setSharedDataByKey("returnUrl", me.returnUrl);
          me._router.navigateByUrl("/registrationdata");
          break;
        }
      case LoginStatus.WrongUserOrPassword:
        {
          me.loginFailed = true;
          me.PushChanges();
          break;
        }
    }
  }

  public ngOnInit() {
    const me = this;
    me.loginTitleContent = me._coreLanguageService.value("phLogin_Tab_Title").replace("<phloginTitleBreak>", "<br>");
    // Get Data From Resolver Data
    const resolverData = me._activatedRoute.snapshot.data["settingsViewModel"];
    if (resolverData) {
      me.settingsViewModel = resolverData["settingsViewModel"];
      me.termConfirmationViewModels = resolverData["termConfirmationViewModels"];
      if (!me.settingsViewModel) {
        // TODO What should happen after error
        me._snackBarService.ShowErrorMessageFailed(80);
      }
    } else {
      me._coreLogService.error("RegistratinComponent.ngOnInit", "no resolverData settingsViewModel");
      me._router.navigate(["/"]); // back to home
      return;
    }

    // Get Data From Shared Service
    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"];
    me.hasForgetPassword = routeTargetData ? routeTargetData.forgetPassword || false : false;
    me.returnUrl = routeTargetData && routeTargetData.returnUrl && routeTargetData.returnUrl !== "/" ? routeTargetData.returnUrl : "/userprofile";
    const tabIndex = routeTargetData ? routeTargetData.tabIndex || 0 : 0;
    me.currentHeaderIndex = tabIndex;

    me.langSubscriber = me.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

    me._shareDataService.resetSharedData();
    this.loadThirdpartySetting();
    me.PushChanges();
  }

  public async ngAfterViewInit(): Promise<void> {
    const me = this;
    // Set privacy content link after selecting register tab
    if (me.currentHeaderIndex === 0) {
      me.setTermConditionsClick();
    } else {
      me.rebindUserData(me);
    }
    me.setLoginFormSubscriber();
  }

  /**define an observable on login form to control form email validation error message */
  private setLoginFormSubscriber() {
    const me = this;
    setTimeout(() => {
      if (me.loginForm) {
        me.loginformSubscriber = me.loginForm.form.statusChanges.subscribe(status => {
          if (status === "INVALID") {
            me.loginFailed = false;
          }
        })
      }
    }, 200);
  }

  /**
   * to fix the problem for inputs. input in login tab locked when browser fill them by saved user and password
   * it is a Temporary solution and needs to be change when we find another solution
   */
  private rebindUserData(me: this) {
    setTimeout(() => {
      if (me.loginViewModel && me.loginViewModel.userName && me.loginViewModel.password) {
        const userData = _.clone(me.loginViewModel);
        me.loginViewModel = new RegisterationUserViewModel();
        me.PushChanges();
        me.loginViewModel.userName = userData.userName;
        me.loginViewModel.password = userData.password;
        me.PushChanges();
      }
    }, 1000);
  }

  // set privacy Content for user
  // create link to show privacy message in a modal dialog
  private setTermConditionsClick() {
    const me = this;
    me._renderer.setProperty(me.privacyContent.nativeElement, "innerHTML", me.settingsViewModel.register_term_text);
    const privacyLinkElements = Array.from(document.getElementsByClassName("privacyLink"));
    privacyLinkElements.forEach(element => {
      const eleIdArray = element.id.split("-");
      const elementId: number = +(eleIdArray[eleIdArray.length - 1]); // '+' convert string to number
      me._renderer.listen(element, "click", () => {
        me.openTermModel(elementId);
      });
    });
  }

  /**
  * open a modal dialog to show term detail
  * @param term information for term and condition
  */
  public openTermModel(termId: number): void {
    const me = this;
    me._termService.openTermModel(termId);
  }

  public headerTabIndexChange(index: number) {
    const me = this;
    // me.matTabGroup.selectedIndex = index;
    me.PushChanges();
  }

  /**
   * by changing call resetRegisterForm Method to reset form data
   * @param index tab index
   */
  public selectedTabIndexChange(index: number): void {
    const me = this;
    if (index === 0) {
      me.checkPrivacyInvalid = false;
      me.registerViewModel = new RegisterationUserViewModel();
      if (me.loginViewModel.userName && me.loginForm.form.controls["loginUserName"].valid) {
        me.registerViewModel.userName = me.loginViewModel.userName;
        me.PushChanges();
      }
      me.loginViewModel = new RegisterationUserViewModel();
      if (me.loginformSubscriber) {
        me.loginformSubscriber.unsubscribe();
      }
    } else {
      me.loginViewModel = new RegisterationUserViewModel();
      if (me.registerViewModel.userName && me.registerForm.form.controls["registerUserName"].valid) {
        me.loginViewModel.userName = me.registerViewModel.userName;
        me.PushChanges();
      }
      me.registerViewModel = new RegisterationUserViewModel();
      me.rebindUserData(me);
      me.setLoginFormSubscriber();
    }
    me.resetRegisterForm();
  }

  /**
   * runs after tab change. useful to add content to html.
   * @param event MatTabChangeEvent
   */
  public selectedTabChange(event: MatTabChangeEvent) {
    const me = this;
    // set link for privacy content after selecting register tab
    if (event.index === 0) {
      me.setTermConditionsClick();
    } else {

    }
  }

  /**show all validation message by clicking on desabled button */
  public showErrorValidation(formGroup: FormGroup): void {
    const me = this;
    me._formHelperService.showValidationMsg(formGroup);
    me.PushChanges();
  }

  /**
   * try to register user and goes to the next step of registration base on response
   */
  public async submitRegisterData(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      const response = await me._registrationService.RegisterUser(me.registerViewModel, me.termConfirmationViewModels);
      if (response) {
        me.trackRegistrationCompleted();
        // Store newsletter opt-in for after email verification
        const newsletterOptIn = me.newsletterCheckbox ? me.newsletterCheckbox.checked : false;
        me._shareDataService.setSharedDataByKey("newsletterOptIn", newsletterOptIn);
        me._shareDataService.setSharedDataByKey("registerationUserViewModel", me.registerViewModel);
        me._shareDataService.setSharedDataByKey("returnUrl", me.returnUrl);
        me._router.navigateByUrl("/loginactivation");
      } else {
        me.registerFailed = true;
        me.registerFailedMessage = (me._coreLanguageService.value("phRegister_Failed_message")).replace("<email>", me.registerViewModel.userName);
        me.PushChanges();
      }
    } catch (error) {
      me._coreLogService.error("RegistrationComponent.submitRegisterData", "RegisterUser failed", error);
      me._snackBarService.ShowErrorMessageFailed(81);
    } finally {
      me._overlaySpinnerService.HideLayoutSpinner();
    }
  }

  private trackRegistrationCompleted(): void {
    this._trackingManager.trackRegistrationCompleted();
  }

  private ensureFacebookInit(): Promise<void> {
    if (this.fbInitPromise) {
      return this.fbInitPromise;
    }

    this.fbInitPromise = new Promise<void>((resolve, reject) => {
      if (!this.facebookAppId) {
        const msg = "facebookAppId ist nicht gesetzt. Backend-Konfiguration fehlt oder ist noch nicht geladen.";
        this._coreLogService.error("RegistrationComponent.ensureFacebookInit", "facebookAppId", msg);
        reject(new Error(msg));
        return;
      }

      (window as any).fbAsyncInit = () => {
        try {
          FB.init({
            appId: this.facebookAppId,
            cookie: true,
            xfbml: false,
            version: "v20.0",
          });
          resolve();
        } catch (e) {
          reject(e);
        }
      };

      // SDK nur laden, wenn es noch nicht existiert
      const scriptId = "facebook-jssdk";
      if (document.getElementById(scriptId)) {
        const fb = (window as any).FB;
        if (fb && (fb as any).getLoginStatus) {
          resolve();
        }
        return;
      }

      const js = document.createElement("script");
      js.id = scriptId;
      js.async = true;
      js.defer = true;
      js.src = "https://connect.facebook.net/de_DE/sdk.js";
      js.onerror = (err) => reject(err);

      document.body.appendChild(js);
    });

    return this.fbInitPromise;
  }

  private async loadThirdpartySetting(): Promise<void> {
    try {
      const settings = await this._settingsService.GetSettingRegistrationViewModel();
      this.thirdpartyLoginEnabled = settings.thirdparty_login_enabled;
      this.googleClientId = settings.google_client_id;
      this.facebookAppId = settings.facebook_app_id;
      this.thirdpartyGoogleEnabled = this.thirdpartyLoginEnabled && !!this.googleClientId;
      this.thirdpartyFacebookEnabled = this.thirdpartyLoginEnabled && !!this.facebookAppId;

      // Google Identity Services initialization
      if (!this._coreCOMService.environment.client.isMobile &&
        this.thirdpartyGoogleEnabled && typeof google !== "undefined") {
        google.accounts.id.initialize({
          client_id: this.googleClientId,
          use_fedcm_for_prompt: true,
          auto_select: false,
          prompt_parent_id: "google-prompt-container",
          context: "signin",
          callback: (resp) => {
            const idToken = resp.credential;
            if (!idToken) {
              this._snackBarService.ShowErrorMessageFailed(81);
              return;
            }
            this.sendGoogleTokenToBackend(idToken);
          }
        });
      }
    } catch (err) {
      this.thirdpartyLoginEnabled = false;
      this._coreLogService.error('RegistrationComponent', 'loadThirdpartySetting', err);
    } finally {
      this._cdr.markForCheck();
    }
  }

  /**
   * starts Google registration.
   * Uses the mobile OAuth redirect flow on app clients
   * and Google Identity Services on browser clients
   */
  public onGoogleRegister(): void {
    if (this._coreCOMService.environment.client.isMobile) {
      this._registrationService.StartGoogleOAuthRedirect()
        .catch((error) => this._coreLogService.error(
          "RegistrationComponent.onGoogleRegister",
          "StartGoogleOAuthRedirect",
          error
        ));
      return;
    }

    if (typeof google === "undefined") {
      this._coreLogService.error("RegistrationComponent.onGoogleRegister", "google identity services not available");
      return;
    }

    google.accounts.id.prompt((notification: any) => {
      if (notification.isNotDisplayed()) {
        this._coreLogService.info("RegistrationComponent.onGoogleRegister", "google.accounts.id.prompt notification.isNotDisplayed", notification.getNotDisplayedReason());
      }
      if (notification.isSkippedMoment()) {
        this._coreLogService.info("RegistrationComponent.onGoogleRegister", "google.accounts.id.prompt notification.isSkippedMoment", notification.getSkippedReason());
      }
    });
  }

  public sendGoogleTokenToBackend(idToken: string): void {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();

    me._registrationService.RegisterUserWithGoogle(idToken, this.googleClientId, me.termConfirmationViewModels)
      .then((status: LoginStatus) => {
        me.setLoginResponse(status);
      })
      .catch(error => {
        me._coreLogService.error(
          "RegistrationComponent.sendGoogleTokenToBackend",
          "_registrationService.RegisterUserWithGoogle",
          error
        );
      })
      .then(() => {
        me._overlaySpinnerService.HideLayoutSpinner();
      });
  }

  public async onFacebookRegister(): Promise<void> {
    await this.ensureFacebookInit();

    if (typeof FB === "undefined") {
      this._coreLogService.error("RegistrationComponent.onFacebookRegister", "FB === undefined", "FB is undefined.");
      return;
    }
    FB.login((response: any) => {
      if (response.authResponse && response.authResponse.accessToken) {
        this.sendFacebookTokenToBackend(response.authResponse.accessToken);
      } else {
        this._coreLogService.error("RegistrationComponent.onFacebookRegister", "response.authResponse && response.authResponse.accessToken", "no access Token.");
      }
    }, { scope: "public_profile,email", return_scopes: true });
  }

  public sendFacebookTokenToBackend(accessToken: string): void {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();

    me._registrationService.RegisterUserWithFacebook(accessToken, me.termConfirmationViewModels)
      .then((status: LoginStatus) => {
        me.setLoginResponse(status);
      })
      .catch(error => {
        this._coreLogService.error(
          "RegistrationComponent.sendFacebookTokenToBackend",
          "_registrationService.RegisterUserWithFacebook",
          error
        );
      })
      .then(() => {
        me._overlaySpinnerService.HideLayoutSpinner();
      });
  }

  /**
   * try to Login user and goes to the next step of Login Or Registration base on response
   */
  public submitLoginData(): void {
    const me = this;
    setTimeout(() => {
      me._overlaySpinnerService.ShowLayoutSpinner();
      me._registrationService.LoginUser(me.loginViewModel)
        .then((response) => {
          me.setLoginResponse(response);
          me._overlaySpinnerService.HideLayoutSpinner();
        }).catch(() => {
          me._overlaySpinnerService.HideLayoutSpinner();
          me._snackBarService.ShowErrorMessageFailed(82);
        });
    }, 300);
  }

  public handleLoginEnterKeyup(event) {
    if (event.keyCode === 13) {
      //document.getElementById("loginButtonContainer").getElementsByTagName("a")[0].click();
    }
  }

  public handleRegisterEnterKeyup(event) {
    if (event.keyCode === 13) {
      //document.getElementById("registerButtonContainer").getElementsByTagName("a")[0].click();
    }
  }

  public privacyCheckeChange(event: MatCheckboxChange) {
    const me = this;
    me.checkPrivacyInvalid = !me.chkTerm.checked;
    me.PushChanges();
  }

  /**
   * route to Forget Password
   */
  public navigateToForgetPassword(): void {
    const me = this;
    if (me.loginViewModel.userName && me.loginForm.form.controls["loginUserName"].valid) {
      me._routerHelperService.setRouteTargetDataByKey("userName", me.loginViewModel.userName);
    }
    me._router.navigateByUrl("/forgetpassword");
  }

  public swipeRightHandler() {
    const me = this;
    if (me.currentHeaderIndex > 0) {
      // --me.matTabGroup.selectedIndex;
      --me.currentHeaderIndex;
      me.PushChanges();
    }
  }

  public swipeLeftHandler() {
    const me = this;
    if (me.currentHeaderIndex < 1) {
      // ++me.matTabGroup.selectedIndex;
      ++me.currentHeaderIndex;
      me.PushChanges();
    }
  }

  public navigateBack(): void {
    const me = this;
    me._location.back();
  }

  public ngOnDestroy(): void {
    const me = this;
    if (me.loginformSubscriber) {
      me.loginformSubscriber.unsubscribe();
    }
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
  }
}
